// extracted by mini-css-extract-plugin
export var active = "_3o-7";
export var container = "_3o-0";
export var evenWidth = "_3o-4";
export var large = "_3o-5";
export var outlet = "_3o-8";
export var slide = "_3o-2";
export var small = "_3o-6";
export var tab = "_3o-3";
export var tabs = "_3o-1";